import { Component, OnInit } from '@angular/core';
import { ConsultaService } from '../../services/consulta.service';
import { Router } from '@angular/router';
import { IMyOptions, IMyDateModel } from 'mydatepicker';

import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';

import { Filtro } from '../../../conf/clases';
import { Venta } from '../../../conf/clases';
import { Detalle } from '../../../conf/clases';

declare var jquery: any;
declare var $: any;
declare var bootbox: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {




  replaceCeroFecha(param: any): any {
    var mes = "";
    if (param < 10) {
      mes = param.replace("0", "");
    } else {
      mes = param;
    }
    return mes;
  }

  datosExcel: any;
  private myDatePickerOptions: IMyOptions = {
    // other options...
    dateFormat: 'yyyy/mm/dd',
    todayBtnTxt: 'Hoy',
    dayLabels: { su: 'Dom', mo: 'Lun', tu: 'Mar', we: 'Mie', th: 'Jue', fr: 'Vie', sa: 'Sab' },
    monthLabels: { 1: 'Ene', 2: 'Feb', 3: 'Mar', 4: 'Abr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dic' }
  };

  fechaInicio: any;
  fechaFin: any;
  detFechaUso: { date: { year: any; month: any; day: any; }; };
  detFechaInicio: { date: { year: any; month: any; day: any; }; };
  detFechaFin: { date: { year: any; month: any; day: any; }; };

  coincidencias: any = [];
  filtro: Filtro;
  venta: Venta;
  detalle: Detalle;


  constructor(private router: Router, private consultaService: ConsultaService) {

  }

  initFiltro() {
    this.filtro = new Filtro();
    this.filtro.adulto = false;
    this.filtro.nino = false;
    this.filtro.jardines = false;
    this.filtro.hacienda = false;
    this.filtro.zoofari = false;
    this.filtro.estacas = false;
    this.filtro.inicio = null;
    this.filtro.fin = null;
    this.filtro.texto = "";
    this.filtro.tipoBusqueda = -1;
    this.fechaInicio = {};
    this.fechaFin = {};
  }

  initVenta(): any {
    this.venta = new Venta();
    this.venta.boletin = "";
    this.venta.contrasenia = "";
    this.venta.correo = "";
    this.venta.estatus = "";
    this.venta.id = "";
    this.venta.nombre = "";
    this.venta.primerApellido = "";
    this.venta.segundoApellido = "";
    this.venta.token = "";
  }

  initDetalle(): any {
    this.detalle = new Detalle();
    this.detalle.correo = "";
    this.detalle.estatus = "";
    this.detalle.fechaFin = "";
    this.detalle.fechaInicio = "";
    this.detalle.fechaUso = "";
    this.detalle.id = "";
    this.detalle.idEmpresa = "";
    this.detalle.idPaquete = "";
    this.detalle.idProducto = "";
    this.detalle.idTipoPase = "";
    this.detalle.idUsuario = "";
    this.detalle.idUsuarioEmpresa = "";
    this.detalle.idVenta = "";
    this.detalle.nombre = "";
    this.detalle.nota = "";
    this.detalle.primerapellido = "";
    this.detalle.segundoapellido = "";
    this.detalle.titular = "";
    this.detFechaUso = { date: { year: "", month: "", day: "" } };
    this.detFechaInicio = { date: { year: "", month: "", day: "" } };
    this.detFechaFin = { date: { year: "", month: "", day: "" } };

  }
  ngOnInit() {
    window.scrollTo(500, 0);
    this.initFiltro();
    this.initVenta();
    this.initDetalle();
  }

  clickBuscar() {
    $("#loading").modal('show');
    console.log("Entro a clickBuscar");

    this.filtro.inicio="";
    this.filtro.fin="";

    console.log(this.fechaInicio);
    if (this.fechaInicio != null) {
      this.filtro.inicio = this.fechaInicio.formatted;
    }
    if (this.fechaFin != null) {
      this.filtro.fin = this.fechaFin.formatted;
    }
    this.consultaService.obtieneCoincidencias(this.filtro).then(resolve => {
      this.coincidencias = this.consultaService.coincidencias;
      if (this.coincidencias.length == 50) {
        bootbox.alert("<strong>Alerta</strong><br/><hr/>Se mostraran los primeros 50 resultados, si quieres ver toda la información genera el Excel.")
      }
      $("#loading").modal('hide');
    });
  }


  editaVenta(idVenta: any) {
    this.initVenta();
    console.log("editaVenta", idVenta);
    this.consultaService.obtieneVenta(idVenta).then(resolve => {
      this.venta = this.consultaService.venta;
      console.log(this.venta);
    })

  }

  editaDetalle(idDetalle: any) {
    this.initDetalle();
    console.log("editaDetalle", idDetalle);
    this.consultaService.obtieneDetalle(idDetalle).then(resolve => {
      this.detalle = this.consultaService.detalle;
      console.log(this.detalle);
      //yyyy-mm-dd
      let splitInicio = this.detalle.fechaInicio;
      let x = splitInicio.split("-");
      var diaInicio = this.replaceCeroFecha(x[2]);
      var mesInicio = this.replaceCeroFecha(x[1]);
      this.detFechaInicio = { date: { year: x[0], month: mesInicio, day: diaInicio } };

      let splitFin = this.detalle.fechaFin;
      let y = splitFin.split("-");
      console.log(y);
      var diaFin = this.replaceCeroFecha(y[2]);
      var mesFin = this.replaceCeroFecha(y[1]);
      this.detFechaFin = { date: { year: y[0], month: mesFin, day: diaFin } };

      if (this.detalle.fechaUso != null) {
        let splitUso = this.detalle.fechaUso;
        let z = splitUso.split("-");
        var diaUso = this.replaceCeroFecha(z[2]);
        var mesUso = this.replaceCeroFecha(z[1]);
        this.detFechaUso = { date: { year: z[0], month: mesUso, day: diaUso } };
      } else { this.detFechaUso = null }

    });

  }

  clickExcel() {    $("#loading").modal('show');
    this.consultaService.obtieneDatosExcel(this.filtro).then(resolve => {
      this.datosExcel = this.consultaService.datosExcel;
      const ws_name = 'Resultado_busqueda';
      const wb: WorkBook = { SheetNames: [], Sheets: {} };
      const ws: any = utils.json_to_sheet(this.datosExcel);
      wb.SheetNames.push(ws_name);
      wb.Sheets[ws_name] = ws;
      const wbout = write(wb, {
        bookType: 'xlsx', bookSST: true, type:
          'binary'
      });

      function s2ab(s) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
          view[i] = s.charCodeAt(i) & 0xFF;
        };
        return buf;
      }

      saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
      $("#loading").modal('hide');
    })
  }

  onDateChanged(event: IMyDateModel) {
    // event properties are: event.date, event.jsdate, event.formatted and event.epoc
  }


  clickGuardarDetalle() {

    if(this.detFechaInicio!=null){
    let dateInicio = this.detFechaInicio.date.year+'-'+this.detFechaInicio.date.month+'-'+this.detFechaInicio.date.day;
    let newDateI = new Date(dateInicio);
    //console.log(newDateI.toLocaleDateString())
    this.detalle.fechaInicio=newDateI;
    }else{
      this.detalle.fechaInicio=null;
    }
    
    if(this.detFechaFin!=null){
    let dateFin = this.detFechaFin.date.year+'-'+this.detFechaFin.date.month+'-'+this.detFechaFin.date.day;
    let newDateF = new Date(dateFin);
    this.detalle.fechaFin=newDateF;
  }else{
    this.detalle.fechaFin=null;
  }
   
    if(this.detFechaUso!=null){
      let dateUso = this.detFechaUso.date.year+'-'+this.detFechaUso.date.month+'-'+this.detFechaUso.date.day;
      let newDateU = new Date(dateUso);
      this.detalle.fechaUso=newDateU;
    }else{
      this.detalle.fechaUso=null;
    }

    console.log()
    this.consultaService.actualizarDetalle(this.detalle).then(resolve => {
      this.clickBuscar();
      bootbox.alert("<strong>Alerta</strong><br/><br/> Datos guardados correctamente");
    });

  }

  clickGuardarVenta() {
    this.consultaService.actualizarVenta(this.venta).then(resolve => {
      this.clickBuscar();
      bootbox.alert("<strong>Alerta</strong><br/><br/> Datos guardados correctamente");
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/home/home.component.ts